import { render, staticRenderFns } from "./publicSafety.vue?vue&type=template&id=42f8543b&"
import script from "./publicSafety.vue?vue&type=script&lang=js&"
export * from "./publicSafety.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports